export function findSection(sections, condition) {
  let found = null;

  const loop = (section) => {
    if (condition(section)) {
      found = section;
    }

    return found;
  };

  sections.some(loop);

  return found;
}

export default function find(sections, condition) {
  let found = null;

  const loopItems = (item) => {
    if (condition(item)) {
      found = item;
    }

    return found;
  };

  const loopSections = (section) => {
    section.items.some(loopItems);

    return found;
  };

  sections.some(loopSections);

  return found;
}
